<template>
<!-- Preview order -->
<div class="checkout-review-order mt20">
  <div class="content-box tax-price">
    <h3
      class="is-size-4 mb10">
      Order Summary
    </h3>
    <table class="cart-table">
      <tr v-bind:key="'cart_table_item_' + index" v-for="(product, index) in vg_cartItems">
        <td class="td-product-name is-size-14">{{ product.product_name }}</td>
        <td
          class="td-product-info text-right is-size-14"
        >{{ product.selected_variant.weight_equivalent_dry_cannabis }}{{ product.weighing_unit ? product.weighing_unit : '' }} X {{ product.unit }}</td>
        <td
          class="td-product-price text-right is-size-14"
        >
          <span v-if="hasSalePrice(product)" class="opacity-8 "><s class="opacity-03">${{ (product.unit * product.selected_variant.price).toFixed(2)}}</s><br/></span>
          ${{ (product.unit * product.price).toFixed(2) }}
        </td>
      </tr>
    </table>
  </div>

  <div class="content-box subtotal-box">
    <div class="level is-mobile mb5" v-if="!vg_is_greenline_pos">
      <div class="level-left">
        <div class="level-item">
          <p class="sf-pro-text-regular is-size-14 ">Subtotal</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class="sf-pro-text-regular  is-size-14">
            <!-- <span class="subtotal-without-sale-price" v-if="activeSalePriceData.hasActiveSale">
              <s class="opacity-03">${{ activeSalePriceData.regularPrice}}</s>
            </span> -->
            <span :class="(vg_cartPromoCode || vg_cartLoyality) ? 'strike': ''">${{ vg_cartSubTotal }}</span>
          </p>
        </div>
      </div>
    </div>

    <div class="level is-mobile mb5" v-if="vg_is_greenline_pos">
      <div class="level-left">
        <div class="level-item">
          <p class="sf-pro-text-regular is-size-14">Deposit</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class="sf-pro-text-regular is-size-14">
            ${{ vg_greenlineProductDeposit }}
          </p>
        </div>
      </div>
    </div>

    <div class="level is-mobile mb5" v-if="vg_cartPromoCode">
      <div class="level-left">
        <div class="level-item">
          <p class="sf-pro-text-regular is-size-14">Promo Code: {{ vg_cartPromoCode.code}}</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class="sf-pro-text-regular text-green is-size-14">
            - ${{ vg_cartPromoCode.applied_value.toFixed(2) }} 
          </p>
        </div>
      </div>
    </div>

    <div class="level is-mobile mb5" v-if="vg_cartLoyality">
      <div class="level-left">
        <div class="level-item">
          <p class="sf-pro-text-regular is-size-14"> Points Used: {{ new Intl.NumberFormat().format(vg_cartLoyality.points_to_redeem) }}</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class="sf-pro-text-regular text-green is-size-14">
            - ${{ vg_cartLoyality.redeem_amount.toFixed(2) }} 
          </p>
        </div>
      </div>
    </div>

    <div class="level is-mobile mb5" v-if="!vg_is_greenline_pos && (vg_cartPromoCode || vg_cartLoyality)">
      <div class="level-left">
        <div class="level-item">
          <p class="sf-pro-text-regular is-size-14">New Subtotal</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class="sf-pro-text-regular text-green is-size-14">${{ vg_newSubTotal }}</p>
        </div>
      </div>
    </div>

    <div class="level is-mobile mb5">
      <div class="level-left">
        <div class="level-item">
          <p class=" sf-pro-text-regular is-size-14 ">Tax</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class=" sf-pro-text-regular is-size-14 ">${{ vg_cartTax ? vg_cartTax : 0.00 }}</p>
        </div>
      </div>
    </div>

    

    <div class="level is-mobile mb5" v-if="vg_checkoutOrderType.order_receive_method == 'delivery'">
      <div class="level-left">
        <div class="level-item">
          <p class=" sf-pro-text-regular is-size-14 ">Delivery Fee</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <!-- we have case if greenline only show the delivery fee once we have -->
          <p
            class=" sf-pro-text-regular  is-size-14"
          >${{ parseFloat(vg_checkoutOrderType.delivery_fee).toFixed(2) }}</p>
        </div>
      </div>
    </div>

    <div class="level is-mobile mb5" v-if="vg_checkoutOrderType.order_receive_method == 'delivery' && vg_selectedStore.settings && vg_selectedStore.settings.delivery_orders && vg_selectedStore.settings.delivery_orders.enable_tips">
      <div class="level-left">
        <div class="level-item">
          <p class=" sf-pro-text-regular is-size-14 ">Tip</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p
            class=" sf-pro-text-regular  is-size-14"
          >${{ parseFloat(vg_checkoutOrderType.tip).toFixed(2) }}</p>
        </div>
      </div>
    </div>


    <div class="level is-mobile mb5">
      <div class="level-left">
        <div class="level-item">
          <p class="is-size-16 has-text-weight-bold ">Total</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p v-if="vg_is_greenline_pos || vg_is_tendy_pos" class="is-size-16 has-text-weight-bold ">${{ vg_cartGrandTotal }}</p>
          <p v-else class="is-size-16 has-text-weight-bold ">${{ vg_checkoutOrderType.order_receive_method == 'pickup' ? vg_cartGrandTotal : cartGrandTotalWithDelivery.toFixed(2) }}</p>
        </div>
      </div>
    </div>

    <div class="level is-mobile" v-if="enabledLoyality">
      <div class="level-left">
        <div class="level-item">
          <p class="is-size-16 has-text-weight-bold">Points Earned</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <p class="is-size-16 has-text-weight-bold ">{{ vg_cartLoyalityPointsObj.points_earned ? new Intl.NumberFormat().format(vg_cartLoyalityPointsObj.points_earned) : 0 }} pts</p>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- Review order ends -->
</template>


<script>
import { mapGetters, mapActions } from "vuex";
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: 'CheckoutOrderSummary',
  data() {
    return {
      order_receive_method: 'pickup',
      delivery_fee: 0,
    };
  },
  computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_userId: "getLoggedInUserId",
      vg_businessprofile: "businessprofile/detail",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_newSubTotal: "cart/newSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_is_tendy_pos: "location/is_tendy_pos",
      vg_greenlineProductDeposit: "cart/greenline_product_deposit",
      vg_cartPromoCode: "cart/promocode",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_checkoutOrderType: "checkout/ordertype",
      vg_cartLoyality: "cart/loyality",
      vg_hasBusinessLoyalityProgram: "businessprofile/hasBusinessLoyalityProgram",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
    }),

    enabledLoyality() {
      if(this.vg_userId && this.vg_userLoyalitySubscription && this.vg_hasBusinessLoyalityProgram){
        return true;
      }
      return false;
    },

    activeSalePriceData() {
      let hasActiveSale = false;
      let regularPrice = 0;
      this.vg_cartItems.map(item => {
        if(parseFloat(item.selected_variant.sale_price) > 0 && parseFloat(item.selected_variant.sale_price) < parseFloat(item.selected_variant.price)){
          hasActiveSale = true;
        } 
        regularPrice += item.unit * item.selected_variant.price;
      })
      return {
        hasActiveSale,
        regularPrice: regularPrice.toFixed(2)
      };
    },

    cartGrandTotalWithDelivery() {
      return parseFloat(this.vg_cartGrandTotal) + parseFloat(this.vg_checkoutOrderType.delivery_fee) + parseFloat(this.vg_checkoutOrderType.tip) ;
    },
    
    
  },

  async mounted() {

  },
  
  beforeDestroy() {

  },

  methods: {

    hasSalePrice(item) {
      if(parseFloat(item.selected_variant.sale_price) > 0 && parseFloat(item.selected_variant.sale_price) < parseFloat(item.selected_variant.price)){
        return true;
      }
      return false;
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
    })

  },
};
</script>
